import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDivider} from "@angular/material/divider";
import {NgForOf, NgIf} from "@angular/common";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {SignatureComponent} from "../../../signature/signature.component";
import {BasicInfoFieldNames} from "../../../basic-info/basic.patient.info.types";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {DocummentsService} from "../../../documents.service";
import {DocUserField, GeneralFieldNames, InternalDocDefinition, InternalDocummentID} from "../../../document-types";
import {ActivatedRoute, Router} from "@angular/router";
import {BasicWizzard} from "../../../base-behaviour/wizzard";
import {getRawVal, getValueOfFieldWithName, iWizzard} from "../../../base-behaviour/base.behaviour.doc.types";
import {ChestEvalGenStareSanFieldNames} from "../../chest-eval-gen-stare-sanatate.types";
import {BulInfQ, bulInfQuestions, BullInfAnsw} from "../buletin-informativ-types";
import {GDPRAnsw, GdprQ} from "../../../GDPR-consimtamant/gdpr-sib-v1/gdpr.consimtamant.sib.v1.types";
import {FuseAlertComponent} from "../../../../../../@fuse/components/alert";

@Component({
    selector     : 'buletin-informativ-sib-v1-wizzard',
    templateUrl  : 'buletin.informativ.wizzard.sib.v1.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    styles: `
        input[type=checkbox] {
            transform: scale(1.5);
        }
    `,
    imports: [MatIconModule, FormsModule, ReactiveFormsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDivider, NgIf, TranslocoPipe, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, SignatureComponent, MatSlideToggle, NgForOf, FuseAlertComponent],
})
export class BuletinInformativWizzardSibV1 extends BasicWizzard implements OnInit, OnDestroy
{
    buletinInfForm: UntypedFormGroup;
    @ViewChild(SignatureComponent) signature!: SignatureComponent;
    patched=false;


    fieldsData: Record<ChestEvalGenStareSanFieldNames, boolean|string> = {
        BUL_INFO_SB_V1__info1_1 : false,
        BUL_INFO_SB_V1__info1_2 : false,
        BUL_INFO_SB_V1__info1_2extra : '',

        BUL_INFO_SB_V1__info2_1 : false,
        BUL_INFO_SB_V1__info2_1extra : '',

        BUL_INFO_SB_V1__info3_1 : false,
        BUL_INFO_SB_V1__info3_2 : false,
        BUL_INFO_SB_V1__info3_3 : false,
        BUL_INFO_SB_V1__info3_4 : false,
        BUL_INFO_SB_V1__info3_5 : false,
        BUL_INFO_SB_V1__info3_6 : false,
        BUL_INFO_SB_V1__info3_7 : false,

        BUL_INFO_SB_V1__info4_1 : false,
        BUL_INFO_SB_V1__info4_1extra : '',

        BUL_INFO_SB_V1__info5_1 : false,
        BUL_INFO_SB_V1__info5_1extra : '',

        BUL_INFO_SB_V1__info6_1 : false,

        BUL_INFO_SB_V1__info7_1 : false,
        BUL_INFO_SB_V1__info7_1extra : '',

        BUL_INFO_SB_V1__info8_1 : false,

        BUL_INFO_SB_V1__info9_1 : false,
        BUL_INFO_SB_V1__info9_2 : false,
        BUL_INFO_SB_V1__info9_3 : false,
        BUL_INFO_SB_V1__info9_4 : false,

        BUL_INFO_SB_V1__info10_1 : false,

        BUL_INFO_SB_V1__info11_1 : false,
        BUL_INFO_SB_V1__info11_2 : false,
        BUL_INFO_SB_V1__info11_3 : false,
        BUL_INFO_SB_V1__info11_4 : false,
        BUL_INFO_SB_V1__info11_4extra : '',
        BUL_INFO_SB_V1__info11_5 : false,
        BUL_INFO_SB_V1__info11_6 : false,
        BUL_INFO_SB_V1__info11_7 : false,
        BUL_INFO_SB_V1__info11_8 : false,
        BUL_INFO_SB_V1__info11_9 : false,
        BUL_INFO_SB_V1__info11_10 : false,
        BUL_INFO_SB_V1__info11_11 : false,
        BUL_INFO_SB_V1__info11_12 : false,

        BUL_INFO_SB_V1__info12_1 : false,
        BUL_INFO_SB_V1__info12_2 : false,
        BUL_INFO_SB_V1__info12_3 : false,
        BUL_INFO_SB_V1__info12_4 : false,
        BUL_INFO_SB_V1__info12_5 : false,

        BUL_INFO_SB_V1__info13_1 : false,
        BUL_INFO_SB_V1__info13_2 : false,
        BUL_INFO_SB_V1__info13_3 : false,
        BUL_INFO_SB_V1__info13_4 : false,

        BUL_INFO_SB_V1__info14_1 : false,
        BUL_INFO_SB_V1__info14_2 : false,
        BUL_INFO_SB_V1__info14_3 : false,
        BUL_INFO_SB_V1__info14_4 : false,
        BUL_INFO_SB_V1__info14_5 : false,

        BUL_INFO_SB_V1__info15_1 : false,
        BUL_INFO_SB_V1__info15_2 : false,
        BUL_INFO_SB_V1__info15_3 : false,
        BUL_INFO_SB_V1__info15_4 : false,

        BUL_INFO_SB_V1__info16_1 : false,
        BUL_INFO_SB_V1__info16_2 : false,
        BUL_INFO_SB_V1__info16_3 : false,
        BUL_INFO_SB_V1__info16_4 : false,
        BUL_INFO_SB_V1__info16_5 : false,
        BUL_INFO_SB_V1__info16_6 : false,
        BUL_INFO_SB_V1__info16_7 : false,

        BUL_INFO_SB_V1__info17_1 : false,
        BUL_INFO_SB_V1__info17_2 : false,
        BUL_INFO_SB_V1__info17_3 : false,
        BUL_INFO_SB_V1__info17_4 : false,
        BUL_INFO_SB_V1__info17_5 : false,
        BUL_INFO_SB_V1__info17_6 : false,
        BUL_INFO_SB_V1__info17_7 : false,
        BUL_INFO_SB_V1__info17_8 : false,
        BUL_INFO_SB_V1__info17_9 : false,
        BUL_INFO_SB_V1__info17_10 : false,
        BUL_INFO_SB_V1__info17_10extra : '',

        BUL_INFO_SB_V1__info18_1 : false,
        BUL_INFO_SB_V1__info18_1extra : '',

        BUL_INFO_SB_V1__info19_1 : false,
        BUL_INFO_SB_V1__info19_2 : false,
        BUL_INFO_SB_V1__info19_3 : false,

        BUL_INFO_SB_V1__info20_1 : false,
        BUL_INFO_SB_V1__info20_2 : false,
        BUL_INFO_SB_V1__info20_3 : false,
        BUL_INFO_SB_V1__info20_4 : false,
        BUL_INFO_SB_V1__info20_5 : false,

        BUL_INFO_SB_V1__info21_1 : false,
        BUL_INFO_SB_V1__info21_2 : false,
        BUL_INFO_SB_V1__info21_3 : false,
        BUL_INFO_SB_V1__info21_4 : false,
        BUL_INFO_SB_V1__info21_4extra : '',

        BUL_INFO_SB_V1__info22_1 : false,
        BUL_INFO_SB_V1__info22_2 : false,
        BUL_INFO_SB_V1__info22_3 : false,
        BUL_INFO_SB_V1__info22_4 : false,
        BUL_INFO_SB_V1__info22_5 : false,

        BUL_INFO_SB_V1__info23_1 : false,
        BUL_INFO_SB_V1__info23_1extra : '',

        BUL_INFO_SB_V1__info24_1 : false,

        BUL_INFO_SB_V1__info25_1 : false,

        BUL_INFO_SB_V1__info26_1 : false,
        BUL_INFO_SB_V1__info26_1extra : '',
    }


    /**
     * Constructor
     */
    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        _docsService: DocummentsService,
        route: ActivatedRoute,
        router: Router,
        cdrf: ChangeDetectorRef,
    )
    {
        super(_docsService, route, router, cdrf);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        // Vertical stepper form
        this.buletinInfForm = this._formBuilder.group({
            step1: this._formBuilder.group({
            }),
            step2: this._formBuilder.group({

            }),
        });

        this.init();
    }

    public patchForm(value:DocUserField[]){
        if(!value || value.length == 0 || this.patched) {
            return;
        }

        Object.keys(ChestEvalGenStareSanFieldNames).forEach(key => {
            const fieldVal = getRawVal(getValueOfFieldWithName(value, key, this.documentID));
            if(fieldVal != null) {
                this.fieldsData[key] = fieldVal;
            }
        });

        this.patched = true;
        this.cdrf.markForCheck();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;

    protected readonly bulInfQuestions = bulInfQuestions;


    getAnswerText(answer: BullInfAnsw) {
        return answer.txt
            .replace("{tick}", "")
            .replace("...{extra}...", "")
            .replace("{extra}", "");
    }

    isL1Ticked(id: ChestEvalGenStareSanFieldNames) {
        return this.fieldsData[id];
    }

    syncFieldCheck(answer:BullInfAnsw, $event: Event, entry:BulInfQ): void {
        const newVal = ($event.target as HTMLInputElement).checked;
        this.fieldsData[answer.id] = !!(answer.inverted ? !newVal : newVal);

        const toSync: DocUserField[] = [];
        toSync.push(
            new DocUserField(this.documentID, answer.id, this.fieldsData[answer.id]+"")
        );

        if(answer.inverted){
            //clear all L2 related if first option selected
            entry.answsL2.forEach(answ2 => {
                //reset info
                this.fieldsData[answ2.id] = answ2.txt.includes("{extra}") ? "":false;
                toSync.push(new DocUserField(this.documentID, answ2.id, this.fieldsData[answ2.id]+""))
            })
        }

        this._docsService.syncFields(toSync, this.documentID);
    }

    getSelectionValue(answer: BullInfAnsw) {
        return !!((answer.inverted) ? !this.fieldsData[answer.id] : this.fieldsData[answer.id]);
    }

    syncExtraField(id: string, $event: FocusEvent) {
        this.fieldsData[id] = ($event.target as HTMLInputElement).value;
        const usrF: DocUserField = new DocUserField(this.documentID, id, this.fieldsData[id]+"");
        this._docsService.syncFields([usrF], this.documentID);
    }
}
